module.exports = __webpack_public_path__ + "static/media/RoadMap1.c0f9e1cd.png";